import { render, staticRenderFns } from "./assignment-file.html?vue&type=template&id=d2566d80&scoped=true&"
import script from "./assignment-file.js?vue&type=script&lang=js&"
export * from "./assignment-file.js?vue&type=script&lang=js&"
import style0 from "./assignment-file.css?vue&type=style&index=0&id=d2566d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2566d80",
  null
  
)

export default component.exports